import { FC, SVGProps } from 'react';

const AiAgentIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M2.5 10C2.5 14.1417 5.85757 17.5 10 17.5C14.1424 17.5 17.5 14.1417 17.5 10C17.5 6.97452 15.7089 4.36768 13.1292 3.18188"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.70996 16.1453C5.88024 14.8237 7.05591 13.3561 9.97484 13.3561C12.9262 13.3561 14.0938 14.8318 14.2559 16.1697"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.18359 9.4212C7.62076 10.8739 9.15282 11.6965 10.6055 11.2593C12.0582 10.8221 12.881 9.29087 12.4438 7.83822C12.2702 7.2613 11.924 6.78371 11.4787 6.44495"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.66305 3.53503L4.57887 3.76284C4.26148 4.62184 3.58522 5.29911 2.72744 5.61697L2.5 5.70126L2.72744 5.78556C3.58522 6.10342 4.26148 6.78068 4.57887 7.63968L4.66305 7.86752L4.74723 7.63968C5.06462 6.78068 5.74087 6.10342 6.59865 5.78556L6.82616 5.70126L6.59865 5.61697C5.74087 5.29911 5.06462 4.62184 4.74723 3.76284L4.66305 3.53503Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.08849 2.5C8.94549 2.97056 8.57774 3.33882 8.10791 3.48204C8.57774 3.62527 8.94549 3.99353 9.08849 4.46408C9.23149 3.99353 9.59916 3.62527 10.069 3.48204C9.59916 3.33882 9.23149 2.97056 9.08849 2.5Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default AiAgentIcon;
